export default __webpack_public_path__ + "static/media/referral.62f6c580.svg";